module.exports = __webpack_public_path__ + "static/media/3.0f5b3e47.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/lida/3.JPG
// module id = 538
// module chunks = 0